type HalmParameter = {
  value?: string;
};

type HalmWindow = Window &
  typeof globalThis & {
    getAllHalmsProperty?: (key: string) => HalmParameter | undefined;
  };

type Season = "Spring" | "Summer" | "Fall";

const SUBSCRIPTION_FERTILIZER_SKU = "1001";
const ONETIME_FERTILIZER_SKU = "1002";

const getHalmParameterValue = (key: string) =>
  (window as HalmWindow).getAllHalmsProperty?.(key)?.value;

const getBooleanHalmParameterValue = (key: string) =>
  getHalmParameterValue(key) === "true" ? "true" : "false";

export const getActiveFertilizerSeason = (
  currentSeason: string = "spring",
): Season => {
  if (
    currentSeason === "spring" &&
    getBooleanHalmParameterValue("fertilized_in_spring") === "true"
  ) {
    return "Summer";
  }

  if (
    currentSeason === "summer" &&
    getBooleanHalmParameterValue("fertilized_in_summer") === "true"
  ) {
    return "Fall";
  }

  if (currentSeason === "summer") return "Summer";
  if (currentSeason === "fall") return "Fall";

  return "Spring";
};

const withQuizId = (properties: Record<string, string>) => {
  const quizId = getHalmParameterValue("quiz_id");

  return quizId
    ? {
        ...properties,
        _quiz_id: quizId,
      }
    : properties;
};

export const getFertilizerCartProperties = (
  sku?: string,
  currentSeason?: string,
) => {
  if (sku === SUBSCRIPTION_FERTILIZER_SKU) {
    return withQuizId({
      _organic: getBooleanHalmParameterValue("organic"),
      _fertilized_in_spring: getBooleanHalmParameterValue(
        "fertilized_in_spring",
      ),
      _fertilized_in_summer: getBooleanHalmParameterValue(
        "fertilized_in_summer",
      ),
    });
  }

  if (sku === ONETIME_FERTILIZER_SKU) {
    return withQuizId({
      _organic: getBooleanHalmParameterValue("organic"),
      _season: getActiveFertilizerSeason(currentSeason),
    });
  }

  return undefined;
};

export const areCartPropertiesEqual = (
  left?: Record<string, string> | null,
  right?: Record<string, string>,
) => {
  const normalizedLeft = left ?? {};
  const normalizedRight = right ?? {};
  const keys = new Set([
    ...Object.keys(normalizedLeft),
    ...Object.keys(normalizedRight),
  ]);

  return [...keys].every((key) => normalizedLeft[key] === normalizedRight[key]);
};
